// extracted by mini-css-extract-plugin
export var button = "button-module--button--3dYxK";
export var isFocused = "button-module--is-focused--3awYV";
export var isActive = "button-module--is-active--1wTyl";
export var outlined = "button-module--outlined--3D_CB";
export var isSmall = "button-module--is-small--1uw7-";
export var isBlue = "button-module--is-blue--22_s9";
export var isPink = "button-module--is-pink--1lr0X";
export var isYellow = "button-module--is-yellow--1NS4_";